import React, { useCallback } from 'react';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';

interface CheckpointDropdownResponseProps {
	dropdownItems: PatrolCheckpointDropdown[];
	selectedIDs: number[];
	allowMultiSelect: boolean;
	setSelectedDropdownIDs: (selectedIDs: number[]) => void;
}

const CheckpointDropdownResponse: React.FC<CheckpointDropdownResponseProps> = (
	props,
) => {
	const {
		dropdownItems,
		selectedIDs,
		allowMultiSelect,
		setSelectedDropdownIDs,
	} = props;

	const handleChange = useCallback(
		(event: { target: { value: any } }) => {
			const value = allowMultiSelect
				? event.target.value
				: [event.target.value];
			setSelectedDropdownIDs(value);
		},
		[allowMultiSelect, setSelectedDropdownIDs],
	);

	const getNames = useCallback(
		(selectedIDs: number[]) => {
			return selectedIDs
				.map((id) => {
					const item = dropdownItems.find(
						(item) => item.DropdownID === id,
					);
					return item ? item.Name : '';
				})
				.join(', ');
		},
		[dropdownItems],
	);

	return (
		<FormControl
			fullWidth
			sx={{
				marginRight: '1rem',
				marginBottom: '0.5rem',
			}}
		>
			<Select
				value={selectedIDs}
				onChange={handleChange}
				renderValue={allowMultiSelect ? getNames : undefined}
				multiple={allowMultiSelect}
			>
				{dropdownItems.map((dropdown) => (
					<MenuItem
						key={dropdown.DropdownID}
						value={dropdown.DropdownID}
					>
						{allowMultiSelect && (
							<Checkbox
								checked={selectedIDs.includes(
									dropdown.DropdownID,
								)}
							/>
						)}
						<ListItemText primary={dropdown.Name} />
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};

export default CheckpointDropdownResponse;
